import { LoyaltyHomepage, useIsLoyaltyHomepageEnabled } from '@fhs/loyalty-homepage';
import { MqSwitch, createMqStyles } from '@fhs/ui';

import { HomeCard } from './home-card';
import { ScreenHomeDesktop } from './screen-home-desktop';
import { ScreenHomeMobile } from './screen-home-mobile';
import { ScreenHomeProps } from './types';

export { ScreenHomeProps } from './types';

export function ScreenHome(props: ScreenHomeProps) {
  const mqStyles = useMqStyles();
  const isLoyaltyHomepageEnabled = useIsLoyaltyHomepageEnabled();

  if (isLoyaltyHomepageEnabled) {
    return (
      <LoyaltyHomepage
        {...props}
        legacyHomeCard={
          <HomeCard
            style={mqStyles.container}
            logReorderCardPress={props.logReorderCardPress}
            displayedOrder={props.displayedOrder}
            displayedOrderCardLoading={props.displayedOrderCardLoading}
            redirectPath={props.redirectPath}
            onReorder={props.onReorder}
            reorderLoading={props.reorderLoading}
            isLoadingChallenges={props.isLoadingChallenges}
            loyaltyUserReady={props.loyaltyUserReady}
            isDesktop={props.isDesktop}
            challengeHomeCardProps={props.challengeHomeCardProps}
            noEmptyState
          />
        }
      />
    );
  }

  return (
    <MqSwitch
      $base={() => <ScreenHomeMobile {...props} />}
      $gteDesktop={() => <ScreenHomeDesktop {...props} />}
    />
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      maxWidth: 1400,
      width: '100%',
      marginHorizontal: 'auto',
      paddingHorizontal: 16,
    },
    $gteDesktop: {
      paddingHorizontal: 32,
    },
  },
});
